// Staff app shell — teacher and counsellor navigation for the staff surface.
// The paper workspace is the teacher's front door. Every teacher authors —
// into CWY's shared bank in CWY's own workspace, into their own school's bank
// in a school (the server decides which) — so Author is in every teacher's nav.
import { SidebarShell, type ShellNavItem } from '@/components/SidebarShell';
import { useClaims } from '@/hooks/useSession';
import { TeacherYearSwitcher } from '@/components/teacher/TeacherYearSwitcher';

const TEACHER_NAV: ShellNavItem[] = [
  { to: '/teacher/papers', label: 'My papers', icon: 'file-text' },
  { to: '/teacher/analytics', label: 'Analytics', icon: 'bar-chart' },
  { to: '/teacher/reports', label: 'Review queue', icon: 'layers' },
  { to: '/teacher/author', label: 'Author', icon: 'book' },
];

export function AppShell() {
  const claims = useClaims();
  const nav =
    claims?.role === 'TEACHER'
      ? TEACHER_NAV
      : [{ to: '/teacher/analytics', label: 'Analytics', icon: 'bar-chart' as const }];

  // No subtitle: the header's RoleBadge already says "Teacher", and passing the
  // same label alongside it printed the role twice. The year switcher (and
  // "Class teacher · 10-A") sits beside it: every list below reads one year.
  return (
    <SidebarShell
      nav={nav}
      homeTo="/teacher"
      collapseKey="cwy-staff-sidebar-collapsed"
      headerExtras={<TeacherYearSwitcher />}
    />
  );
}
